import { Label, Switch, TimePicker } from "@racoon/ui";
import { Namespace, useT } from "@racoon/i18n";

export const DEFAULT_AUTO_GENERATE_TIME = "14:00";

type Props = {
  id: string;
  enabled: boolean;
  /** "HH:mm"; kept while switched off so switching back on restores it. */
  time: string;
  onEnabledChange: (enabled: boolean) => void;
  onTimeChange: (time: string) => void;
};

export const AutoGenerateTimeField = ({
  id,
  enabled,
  time,
  onEnabledChange,
  onTimeChange,
}: Props) => {
  const t = useT();

  return (
    <div className="flex w-full items-start justify-between rounded-lg border border-border-primary bg-slate-100 p-2">
      <div className="flex min-w-0 flex-1 flex-col justify-center self-stretch p-4">
        <div className="flex items-center gap-4">
          <Switch
            id={id}
            checked={enabled}
            onCheckedChange={onEnabledChange}
            className="h-5 w-9 data-[state=checked]:bg-surface-action [&>span]:size-4"
          />
          <Label
            htmlFor={id}
            className="w-[200px] text-sm font-medium leading-5 tracking-[-0.2px] text-text-body"
          >
            {t(Namespace.PickupLocation, "groups.autoGenerateTime")}
          </Label>
        </div>
      </div>
      {/* The generator runs every 15 minutes, so the minutes move in 15-minute steps. */}
      <TimePicker
        className="px-2"
        value={time}
        minuteStep={15}
        disabled={!enabled}
        onChange={onTimeChange}
        labels={{
          hours: t(Namespace.PickupLocation, "groups.timePicker.hours"),
          minutes: t(Namespace.PickupLocation, "groups.timePicker.minutes"),
          increase: t(Namespace.PickupLocation, "groups.timePicker.increase"),
          decrease: t(Namespace.PickupLocation, "groups.timePicker.decrease"),
        }}
      />
    </div>
  );
};
